import Notification from 'flarum/forum/components/Notification';
import Mithril from 'mithril';
import app from 'flarum/forum/app';

export default class ReputationDecreasedNotification extends Notification {
  icon(): string {
    return 'fas fa-thumbs-down';
  }

  href(): string {
    return '#';
  }

  content(): Mithril.Children {
    return app.translator.trans('justoverclock-reputation-score.forum.reputationDecreasedNotification');
  }

  excerpt(): Mithril.Children {
    return undefined;
  }
}
